class BranchSelectorEvents {
    constructor() {
        const elements = document.querySelectorAll(".branch__list .branch__list-item");
        this.addEventListeners(elements);
    }

    addEventListeners(elements) {
        elements.forEach((element) => {
            element.addEventListener("click", (e) => {
                const branchName = e.target.dataset.branchName;
                if (branchName === undefined)
                    return;

                dataLayer.push({
                    "event": "branchClick",
                    "selectedBranch": branchName
                });

            });
        })
    }
}
document.addEventListener("DOMContentLoaded", function () {
    new BranchSelectorEvents();
});